import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export type MailerStatus = {
  mode: 'resend' | 'smtp' | 'disabled';
  configured: boolean;
  from_address: string | null;
  from_name: string | null;
  reply_to: string | null;
  resend_key_hint: string | null;
  inbound_api_key_hint: string | null;
  inbound_webhook_secret_set: boolean;
  smtp_host: string | null;
  smtp_port: number | null;
  smtp_user: string | null;
  smtp_password_set: boolean;
  smtp_secure: boolean | null;
  updated_at: number | null;
};

export function usePlatformMailer() {
  return useQuery({
    queryKey: ['platform', 'mailer'],
    queryFn: () => api.get<{ mailer: MailerStatus }>('/api/platform/settings/mailer'),
  });
}

export function useSavePlatformMailer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: {
      mode?: 'resend' | 'smtp' | 'disabled';
      from_address?: string;
      from_name?: string;
      reply_to?: string;
      resend_api_key?: string;
      inbound_api_key?: string;
      inbound_webhook_secret?: string;
      smtp_host?: string;
      smtp_port?: number;
      smtp_user?: string;
      smtp_password?: string;
      smtp_secure?: boolean;
    }) => api.put<{ mailer: MailerStatus }>('/api/platform/settings/mailer', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['platform', 'mailer'] }),
  });
}

export function useTestMailer() {
  return useMutation({
    mutationFn: (to: string) =>
      api.post<{ sent: boolean; id: string | null }>('/api/platform/settings/mailer/test', { to }),
  });
}
